import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import React from "react";
import "./assets/styles/theme.scss";

import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import { store, history } from "./store";

import App from "./App";

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </ConnectedRouter>
  </Provider>,

  document.getElementById("root")
);
